import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormSection from 'components/sales/formSection/formSectionNew';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { handleValidateObj } from 'constants/objValues/objvalues';
import Regex from 'services/utils/regex/Regex';
import DatePicker from 'components/sales/datePicker/datePicker';
import FileUpload from 'components/sales/fileUpload/fileUpload';

const LeadDetailsSupply = ({
  LeadSource,
  sourceData,
  handleValue,
  pocSiteType = null,
  pocSiteTypeData = null,
  pocSubSiteTypeData = null,
  pocSubSiteType = null,
  supDropDownData,
  corDropDownData,
  appartmentDropDown,
  b2bDropDown,
  prefilledData = null,
  isDefalut,
  client_name=null,
  documentUploadUrl
}) => {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth()+1; 
  var yyyy = today.getFullYear();
  if(dd<10) {
      dd='0'+dd;
  } 
  if(mm<10) {
      mm='0'+mm;
  } 
  today = dd+'-'+mm+'-'+yyyy;

  const leadDtl = {
    name: '',
    sourceLead: { id: null, value: '' },
    contact_date: today,
    type_of_ev_charges:'',
    brand:'',
  };
  const leadSiteType = {
    typeSite: { id: null, value: '' },
    catLead: '',
  };

  const [leadDtls, setLeadDtls] = useState(leadDtl);
  const [leadsities, setLeadsities] = useState(leadSiteType);
  const [typeSubSite, setTypeSubSite] = useState({ id: null, value: '' });
  const [siteType, setSiteType] = useState();
  const [source, setSource] = useState();
  const [photos, setPhotos] = useState();

  const setToDefaultValue = () => {
    if (isDefalut === true) {
      setLeadDtls(leadDtl);
      setLeadsities(leadSiteType);
      setTypeSubSite({ id: null, value: '' });
    }
  };

  useEffect(() => setToDefaultValue(), [isDefalut]);

  useEffect(() => {
    if (
      prefilledData?.lead_data !== undefined &&
      prefilledData?.lead_data !== null
    ) {
      const {
        client_name,
        lead_source_id,
        lead_source,
        site_type_id,
        site_type,
        site_sub_type,
        site_sub_type_id,
        other_poc_sites,
        contact_date,
        fmc_name,
        is_marquee_site,
        existing_solution,
        existing_solution_id,
        occupancy,
        occupancy_id
      } = prefilledData?.lead_data;
      setLeadDtls({
        ...leadDtls,
        name: client_name,
        contact_date: contact_date,
        sourceLead: { id: lead_source_id, value: lead_source },
        fmcName: fmc_name,
        existing_setup: {id: existing_solution_id, value: existing_solution},
        occupancy: {id: occupancy_id, value: occupancy},
        marquee_site: {id: (is_marquee_site == 'Yes') ? 1 : 2, value: is_marquee_site},

      });
      setLeadsities({
        ...leadsities,
        typeSite: { id: site_type_id, value: site_type },
      });
      setTimeout(() => {
        setTypeSubSite({
          id: site_sub_type_id ? site_sub_type_id : '',
          value: site_sub_type,
        });
      }, 100);
    }
  }, [prefilledData]);
  useEffect(() => {
    setLeadDtls({
      ...leadDtls,
      name: client_name,
    });
  },[client_name]);

  useEffect(() => {
    if (supDropDownData) {
      const { poc_site_types, sources } = supDropDownData;
      setSiteType(poc_site_types);
      setSource(sources);
    }
  }, [supDropDownData]);

  useEffect(() => {
    setTypeSubSite({ id: null, value: '' });
    if (pocSubSiteType && leadsities.typeSite?.id)
      (async () => await pocSubSiteType(leadsities.typeSite?.id))();
  }, [leadsities.typeSite]);

  const handleLeadData = () => {
    
    const leadsitiesObj = {
        name: leadDtls.name,
        typeSite: leadsities.typeSite.id,
        sourceLead: leadDtls.sourceLead.id,
      };
      const isNotEmpty = handleValidateObj(leadsitiesObj);
      if (isNotEmpty !== false) {
        handleValue({
          ...leadsitiesObj,
          typeSubSite: typeSubSite?.id,
          photos: photos,
          brand:leadDtls?.brand,
          type_of_ev_charges:leadDtls?.type_of_ev_charges
        });
      } else {
        handleValue(null);
      }
  };
  useEffect(() => {
    handleLeadData();
  }, [
    leadDtls,
    prefilledData,
    typeSubSite,
    leadsities,
    photos
  ]);
// console.log(leadDtls);
  return (
    <FormSection title={localization.leadDetails}>
      <div className="form-ctrl-col">
      <ConstantInput
        label={localization.siteName}
        type="text"
        // regex={Regex.text.test(leadDtls?.name)}
        handleChange={(val) => {
          setLeadDtls({ ...leadDtls, name: val });
        }}
        required
        errorMsg={localization.requiredCharacter}
        value={leadDtls.name}
        isStarRequired={true}
      />
      <DropDownInput
        label={localization.LeadSource}
        data={source}
        getIdValue={(val) => {
            setLeadDtls({
            ...leadDtls,
            sourceLead: { id: val.id, value: val.value },
            });
        }}
        required={true}
        errorMsg={localization.requiredLeadSource}
        value={leadDtls.sourceLead.value}
        isStarRequired={true}
        />
        
        <DropDownInput
            label={localization.siteType}
            getIdValue={(val) => {
                setLeadsities({
                ...leadsities,
                typeSite: { id: val.id, value: val.value },
                });
            }}
            data={siteType}
            errorMsg={localization.requiredsiteType}
            required
            value={leadsities.typeSite.value}
        />

        <ConstantInput
            label={localization.brand}
            type="text"
            handleChange={ (val) => {
              setLeadDtls({
                ...leadDtls,
                brand: val,
              })}
            }
            value={leadDtls.brand}
        />

        <DropDownInput
            label={localization.typeOfEVCharges}
            data={[{id:"Slow", name:"Slow"}, {id:"Fast", name:"Fast"}]}
            getIdValue={(val) => {
              setLeadDtls({
                ...leadDtls,
                type_of_ev_charges: val.id,
              });
            }}
            // required={true}
            value={leadDtls.type_of_ev_charges}
        />

        {leadsities.typeSite?.id === 13 && (
        <DropDownInput
            label={localization.siteSubType}
            data={pocSubSiteTypeData && pocSubSiteTypeData}
            getIdValue={(val) => {
            setTypeSubSite({ id: val.id, value: val.value });
            }}
            required={true}
            errorMsg={localization.isRequired}
            value={typeSubSite.value}
        />
        )}
        {(prefilledData?.lead_data !== undefined &&
              prefilledData?.lead_data !== null
            ) ? null : 
            <FileUpload
              id="rel_photos"
              accept=".pdf,.png,.jpg"
              documentUploadUrl={documentUploadUrl}
              onChange={(val) => setPhotos(val.toString())}
              multiple={true}
            >
              <span className="btn btn-transparent">
                {localization.addPhotos}
              </span>
            </FileUpload>
            
            }
      </div>
    </FormSection>
  );
};

LeadDetailsSupply.propTypes = {
  LeadSource: PropTypes.func,
  sourceData: PropTypes.array,
  handleValue: PropTypes.func,
};

export default LeadDetailsSupply;
